import { forceLogout } from "../../utils/authStorageManager";
import NotificationStore from "../../components/NotificationPlugin/NotificationStore";

export const parseError = (response) => {
  // Checks if license is not valid but user is authenticated before
  if (
    response.status === 404 &&
    ["who-am-i", "server-time", "ping", "api-token-logout"].find((item) => response.config.url.includes(item))
  )
    forceLogout();

  if (response.data.message_detail_json) {
    const messageDetailJson = response.data.message_detail_json;

    Object.keys(messageDetailJson).forEach((key) => {
      if (messageDetailJson[key] !== "") {
        response.processed_errors = {
          invalidClasses: { [key]: typeof messageDetailJson[key] === 'object' ? `md-invalid md-error-multi-line md-error-${messageDetailJson[key].length}-lines` : 'md-invalid' },
          messages: { [key]: messageDetailJson[key] }
        };
      }
    })
    console.log(response.processed_errors);
  } else {
    const invalidField = response.data.message_detail;
    const responseCode = response.data.code;
    let messages = "";
    if (responseCode === 40002) {
      messages = `Please enter a valid ${invalidField}.`
    } else if (responseCode === 40001) {
      messages = `The ${invalidField} is required.`
    } else if (responseCode === 40003 || responseCode === 40004) {      
      NotificationStore.notify({
        message: response.data.message_detail,
        icon: "error",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "danger",
      });
    }
    response.processed_errors = {
      invalidClasses: { [invalidField]: "md-invalid" },
      messages: { [invalidField]: messages }
    };
  }

  return (
    response.data.detail ||
    response.data.non_field_errors ||
    response.data.message_detail_json ||
    response.data.message_detail ||
    response.data
  );
};
